import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { Flex } from 'foundations-components/components/Flex';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BaseRichTextEditorError({
  reset
}) {
  return /*#__PURE__*/_jsx(Flex, {
    flexGrow: 1,
    alignSelf: "stretch",
    padding: "500",
    alignItems: "start",
    children: /*#__PURE__*/_jsx(Alert, {
      inlineSize: "100%",
      titleText: I18n.text('composer-ui.editor-utilities.error.title'),
      type: "danger",
      children: /*#__PURE__*/_jsxs(ButtonWrapper, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "composer-ui.editor-utilities.error.description"
        }), reset && /*#__PURE__*/_jsx(Button, {
          size: "extra-small",
          use: "tertiary",
          onClick: reset,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "composer-ui.editor-utilities.error.reset-button"
          })
        })]
      })
    })
  });
}
BaseRichTextEditorError.displayName = 'BaseRichTextEditorError';